import * as i from "react";
import { c as V, a as g, b as q, u as K } from "./index-DcwNtM_b.js";
import { c as U, u as _ } from "./index-5Bhkapwi.js";
import { u as R } from "./index-CDznMoQN.js";
import { P as Y, D as Z } from "./index-C1kx85Np.js";
import { R as z, h as J, u as Q, F as X } from "./Combination-CmNnuUVg.js";
import { P as h } from "./index-DBEov9sD.js";
import { P as p } from "./index-CpDnqHCm.js";
import { jsx as s, jsxs as N, Fragment as O } from "react/jsx-runtime";
var m = "Dialog", [I, ve] = V(m), [ee, u] = I(m), x = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: a,
    defaultOpen: r,
    onOpenChange: o,
    modal: l = !0
  } = e, c = i.useRef(null), f = i.useRef(null), [v, C] = K({
    prop: a,
    defaultProp: r ?? !1,
    onChange: o,
    caller: m
  });
  return /* @__PURE__ */ s(
    ee,
    {
      scope: t,
      triggerRef: c,
      contentRef: f,
      contentId: R(),
      titleId: R(),
      descriptionId: R(),
      open: v,
      onOpenChange: C,
      onOpenToggle: i.useCallback(() => C((H) => !H), [C]),
      modal: l,
      children: n
    }
  );
};
x.displayName = m;
var A = "DialogTrigger", T = i.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = u(A, n), o = _(t, r.triggerRef);
    return /* @__PURE__ */ s(
      p.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": y(r.open),
        ...a,
        ref: o,
        onClick: g(e.onClick, r.onOpenToggle)
      }
    );
  }
);
T.displayName = A;
var P = "DialogPortal", [oe, b] = I(P, {
  forceMount: void 0
}), M = (e) => {
  const { __scopeDialog: t, forceMount: n, children: a, container: r } = e, o = u(P, t);
  return /* @__PURE__ */ s(oe, { scope: t, forceMount: n, children: i.Children.map(a, (l) => /* @__PURE__ */ s(h, { present: n || o.open, children: /* @__PURE__ */ s(Y, { asChild: !0, container: r, children: l }) })) });
};
M.displayName = P;
var D = "DialogOverlay", w = i.forwardRef(
  (e, t) => {
    const n = b(D, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, o = u(D, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ s(h, { present: a || o.open, children: /* @__PURE__ */ s(re, { ...r, ref: t }) }) : null;
  }
);
w.displayName = D;
var te = U("DialogOverlay.RemoveScroll"), re = i.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = u(D, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s(z, { as: te, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ s(
        p.div,
        {
          "data-state": y(r.open),
          ...a,
          ref: t,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), d = "DialogContent", F = i.forwardRef(
  (e, t) => {
    const n = b(d, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, o = u(d, e.__scopeDialog);
    return /* @__PURE__ */ s(h, { present: a || o.open, children: o.modal ? /* @__PURE__ */ s(ne, { ...r, ref: t }) : /* @__PURE__ */ s(ae, { ...r, ref: t }) });
  }
);
F.displayName = d;
var ne = i.forwardRef(
  (e, t) => {
    const n = u(d, e.__scopeDialog), a = i.useRef(null), r = _(t, n.contentRef, a);
    return i.useEffect(() => {
      const o = a.current;
      if (o) return J(o);
    }, []), /* @__PURE__ */ s(
      S,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: g(e.onCloseAutoFocus, (o) => {
          o.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: g(e.onPointerDownOutside, (o) => {
          const l = o.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || c) && o.preventDefault();
        }),
        onFocusOutside: g(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), ae = i.forwardRef(
  (e, t) => {
    const n = u(d, e.__scopeDialog), a = i.useRef(!1), r = i.useRef(!1);
    return /* @__PURE__ */ s(
      S,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          e.onCloseAutoFocus?.(o), o.defaultPrevented || (a.current || n.triggerRef.current?.focus(), o.preventDefault()), a.current = !1, r.current = !1;
        },
        onInteractOutside: (o) => {
          e.onInteractOutside?.(o), o.defaultPrevented || (a.current = !0, o.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const l = o.target;
          n.triggerRef.current?.contains(l) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && r.current && o.preventDefault();
        }
      }
    );
  }
), S = i.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: a, onOpenAutoFocus: r, onCloseAutoFocus: o, ...l } = e, c = u(d, n), f = i.useRef(null), v = _(t, f);
    return Q(), /* @__PURE__ */ N(O, { children: [
      /* @__PURE__ */ s(
        X,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: r,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ s(
            Z,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": y(c.open),
              ...l,
              ref: v,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ N(O, { children: [
        /* @__PURE__ */ s(se, { titleId: c.titleId }),
        /* @__PURE__ */ s(ce, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), E = "DialogTitle", W = i.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = u(E, n);
    return /* @__PURE__ */ s(p.h2, { id: r.titleId, ...a, ref: t });
  }
);
W.displayName = E;
var k = "DialogDescription", G = i.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = u(k, n);
    return /* @__PURE__ */ s(p.p, { id: r.descriptionId, ...a, ref: t });
  }
);
G.displayName = k;
var L = "DialogClose", $ = i.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = u(L, n);
    return /* @__PURE__ */ s(
      p.button,
      {
        type: "button",
        ...a,
        ref: t,
        onClick: g(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
$.displayName = L;
function y(e) {
  return e ? "open" : "closed";
}
var B = "DialogTitleWarning", [Ce, j] = q(B, {
  contentName: d,
  titleName: E,
  docsSlug: "dialog"
}), se = ({ titleId: e }) => {
  const t = j(B), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return i.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, ie = "DialogDescriptionWarning", ce = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${j(ie).contentName}}.`;
  return i.useEffect(() => {
    const r = e.current?.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
}, Re = x, _e = T, he = M, Pe = w, Ee = F, ye = W, Ne = G, Oe = $;
export {
  Ee as C,
  Ne as D,
  Pe as O,
  he as P,
  Re as R,
  ye as T,
  Ce as W,
  _e as a,
  Oe as b,
  ve as c
};
//# sourceMappingURL=index-VfZ_jHkF.js.map
